import { Component, ContentChildren, HostBinding, Input, QueryList, TemplateRef, AfterContentInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { NxTemplateDirective } from '../../directives/nx-template.directive';


@Component({
  // tslint:disable-next-line:component-selector
  selector: "div[headline-box], nx-headline-box",
  templateUrl: "headline-box.html",
  styleUrls: ["./headline-box.scss"]
})
export class HeadlineBoxComponent implements AfterContentInit {

  @HostBinding('class') get class() {
    return this.getHostClass();
  }

  /**
   * indicates, if the context menu of the action button is visible
   */
  public menuVisible = false;

  /**
   * The default class of the host element
   */
  public hostDefaultClass = 'flex flex-row basis-full h-[3rem] px-5';

  /**
   * Additional style for the underlined box style
   */
  public underlineHostClass = 'border-b border-solid border-[#D9D9D9]';

  /**
   * Additional style for the filled box style
   */
  public fillHostClass = 'bg-[#EBEEEF] rounded-t-md';

  /**
   * The default class of the label element
   */
  public labelDefaultClass = 'text-[1rem] font-medium leading-4 pt-[0.875rem]';

  /**
   * The appearance of the box. Can be 'filled' or 'underlined'
   */
  @Input() appearance : 'fill' | 'underline' = 'fill';

  /**
   * Overwrites the default class of the label element
   */
  @Input() labelOverwriteClass: string | undefined;

  /**
   * Classes that sould be added to the default class of the label element
   */
  @Input() labelAdditionalClass: string | undefined;

  /**
   * The label of the box
   */
  @Input() label: string;

  /**
   * icon of the box that should be shown on the start position
   */
  @Input() icon: string | undefined;

  /**
   * Menu items for the context menu. Currently this is the "MenuItem" from PrimeNG,
   * but this will probably change if we start to implement the context menues with our
   * own command pattern. For testing purposes, this works.
   */
  @Input() menuItems: MenuItem[] | undefined;

  /**
   * All templates that are inside the box tag in the parent component
   */
  @ContentChildren(NxTemplateDirective) templates!: QueryList<NxTemplateDirective>;

  /**
   * The template for the start of the box
   */
  public startTemplate: TemplateRef<any> | undefined;

  /**
   * The template for the end of the box
   */
  public endTemplate: TemplateRef<any> | undefined;

  /**
   * The template for the label of the box
   */
  public labelTemplate: TemplateRef<any> | undefined;

  /**
   * The template for displaying a status tag <p-tag>
   */
  public tagTemplate: TemplateRef<any> | undefined;

  constructor(
  ) {
  }

  /**
   * Walks through all templates and assigns them to the corresponding variables
   */
  ngAfterContentInit() {
    this.templates.forEach((item) => {
        switch (item.getType()) {
            case 'start':
                this.startTemplate = item.template;
                break;
            case 'label':
                this.labelTemplate = item.template;
                break;
            case 'tag':
                this.tagTemplate = item.template;
                break;
            case 'end':
              this.endTemplate = item.template;
              break;
        }
    });
  }

  /**
   * Method return the class attribute for the label element
   *
   * @returns string - the class of the label element
   */
  getLabelClass(): string {
    // if we have an overwrite, no merging, just return the overwrite
    if(this.labelOverwriteClass){
      return this.labelOverwriteClass;
    }
    let labelClass = this.labelDefaultClass;
    if(this.labelAdditionalClass){
      labelClass += ' ' + this.labelAdditionalClass;
    }
    return labelClass;
  }

  /**
   * Method return the class attribute for the host element
   *
   * @returns string - the class of the label element
   */
    getHostClass(): string {

      // add the desired style, by default its "filled"
      let hostClass = this.hostDefaultClass;
      if(this.appearance === 'underline'){
        hostClass = hostClass + ' ' + this.underlineHostClass;
      } else {
        hostClass = hostClass + ' ' + this.fillHostClass;
      }
      return hostClass;
    }

  /**
   * Checks, if a button for a context menu should be shown
   * @returns - true, if the button should be shown, false otherwise
   */
  shouldShowButton(): boolean {
    if(this.endTemplate === undefined && this.menuItems !== undefined && this.menuItems.length > 0){
      return true;
    }
    return false;
  }

  /**
   * triggers, when the context menu will be showm and sets the menuVisible flag to true
   */
  public onMenuShow() {
    this.menuVisible = true;
  }

  /**
   * triggers, when the context menu will be hidden and sets the menuVisible flag to false
   */
  public onMenuHide() {
    this.menuVisible = false;
  }

}
